import React, { useState, useEffect, useContext } from "react";
import { Paper, TextareaAutosize } from "@mui/material";
import { MdManageAccounts } from "react-icons/md";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import './../../Style/AddPurchaseTotal.scss'
import axios from "axios";
import { ApiLink } from '../../APILink/ApiLink';
import authHeader from '../../Auth/authHeader';
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import { errorAlert, handleSuccess } from '../../Components/Alerts';
import { FaTimes } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import { getUnitID } from "../../Auth/GetUnitCompany";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { LinkAndClickButton } from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import CircularProgress from '@mui/material/CircularProgress';


function InsertInteres(props) {
    const headers = authHeader();
    const email = LoginUserDetailed();

    const { fiscalYear } = useContext(FiscalYearContext);
    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const [date, setDate] = useState("");
    const [invoiceNR, setInvoiceNR] = useState("");
    const [accountID, setAccountID] = useState("");
    const [total, setTotal] = useState(0);
    const [coment, setComent] = useState("");
    const [unId, setUnID] = useState('')

    const [banks, setBanks] = useState([]);

    const [insertingTransaction, setInsertingTransaction] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        setInsertingTransaction(true);
        if (!invoiceNR) {
            errorAlert("Plotesoni numrin e faturës");
            setInsertingTransaction(false);
            return;
        }
        if (!date) {
            errorAlert("Plotësoni datën e faturës");
            setInsertingTransaction(false);
            return;
        }
        if (!total || total <= 0) {
            errorAlert("Totali nuk duhet të ketë vlerën 0");
            setInsertingTransaction(false);
            return;
        }
        const stateDate = {
            Date: date,
            InvoiceNr: invoiceNR,
            AccountID: accountID,
            Total: total,
            CompanyUnitID: unId > 0 ? unId : null,
            Coment: coment,
            CreatedByUser: email,
        };
        axios.post(ApiLink.API_URL + 'Interes', stateDate, { headers })
            .then(() => {
                handleSuccess("Interesi u shtua me sukses");
                setDate("");
                setAccountID("");
                setInvoiceNR("");
                setComent("");
                setTotal(0);
                setfield(null);
                setInsertingTransaction(false);
                fetchLastInvoiceNr(fiscalYear);
            })
            .catch((error) => {
                setInsertingTransaction(false);
                // console.error(error);
                if (error.response && error.response.status === 409) {
                    setInsertingTransaction(false);
                    errorAlert(error.response.data);
                } else {
                    setInsertingTransaction(false);
                    // errorAlert("An unknown error occurred while processing the request.");
                }
            });
    }

    const fetchBanks = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 102 } });
            setBanks(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchLastInvoiceNr = async (fiscalY) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Interes/InvoiceNr', { headers, params: { fiscalYear: fiscalY } });
            setInvoiceNR(response.data.NextInvoiceNr);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    //Pjesa per select input field suppliers
    const [field, setfield] = useState(null);
    const handleAutocompleteChangeBanks = (event, value) => {
        if (value && value.AccountID) {
            setAccountID(value.AccountID);
            setfield(value);


        } else {
            setAccountID("");
            setfield(null);

        }
    };

    const defaultPropsBanks = {
        options: banks,
        getOptionLabel: (option) =>
            `${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {/* {option.AccountID}<br /> */}
                        {option.AccountName}
                    </span>
                </li>
            </>
        ),
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            let nextField;
            switch (e.target.id) {
                case 'Date':
                    nextField = document.getElementById('Supplier');
                    break;
                case 'Supplier':
                    nextField = document.getElementById('Total');
                    break;
                case 'Total':
                    nextField = document.getElementById('Comment');
                    break;
                case 'Comment':
                    handleSubmit(e);
                    nextField = document.getElementById('Date');
                    break;
                default:
                    return;
            }
            if (nextField && nextField.select) {
                nextField.focus();
                nextField.select();
            }
        }
    };


    useEffect(() => {
        getUnitID(headers).then(setUnID);
    });

    useEffect(() => {
        fetchLastInvoiceNr(fiscalYear);
    }, [fiscalYear])

    useEffect(() => {
        fetchBanks();
    }, [])

    return (
        <div className="AddPurchaseTotal__Container" style={{ paddingTop: "50px" }}>

            <TitleElements
                icon={MdManageAccounts}
                title="Krijo interes/provizion të ri "
            />
            <ElementsParagraph text="Ju lutemi vini re se të gjitha te dhenat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!" />

            <hr></hr>
            <div className="AddPurchaseTotal__Container__AllButtons">
                <div style={{ display: "flex", }}>
                </div>
                <div style={{ display: "flex" }}>
                    <div style={{ marginLeft: "5px" }}>
                        {insertingTransaction ? (
                            <button
                                className="button-15"
                                style={{ background: "#284945" }}
                            >
                                <CircularProgress style={{ color: "white", width: "20px", height: "20px" }} />
                            </button>
                        ) : (
                            <LinkAndClickButton
                                text="Ruaj & Ri"
                                // icon={<FaTimes />}
                                onClick={handleSubmit}
                                link="#"
                            />
                        )}
                    </div>
                    <div style={{ marginLeft: "5px" }}>
                        <LinkAndClickButton
                            text="Mbyll"
                            icon={<FaTimes />}
                            link="/expences/interes"
                        />
                    </div>
                </div>
            </div>
            <HeaderPaperComponent />
            <form className='AddPurchaseTotal__Container__Format' onKeyPress={handleKeyPress}>
                <Paper>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div className='Forma1'>
                            <div className='Boxx'>
                                <TextField
                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                    required
                                    id="invoiceNR"
                                    label="Numri Fatures"
                                    variant="outlined"
                                    type="text"
                                    name='InvoiceNr'
                                    value={"INS-" + fiscalYear + "-" + invoiceNR}
                                    onChange={event => setInvoiceNR(event.target.value)}
                                    disabled
                                />

                                <div className='AddPurchaseTotal__Container__Format__Dates'>
                                    <TextField
                                        // style={{ width: "230px" }}
                                        className="AddPurchaseTotal__Container__Format__SameInput"
                                        id="Date"
                                        type="date"
                                        variant="outlined"
                                        name='Date'
                                        label="Data Fatures"
                                        value={date}
                                        onChange={(e) => { setDate(e.target.value); }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            min: minDate, // Kufizimi minimal i datës
                                            max: maxDate, // Kufizimi maksimal i datës
                                        }}
                                    />
                                </div>
                                <div className="textfield_button">
                                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                        <Autocomplete
                                            fullWidth
                                            {...defaultPropsBanks}
                                            id="Supplier"
                                            includeInputInList
                                            value={field}  // Lidheni me state-in `selectedArticle`
                                            onChange={handleAutocompleteChangeBanks}
                                            isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                            renderInput={(params) => (
                                                <TextField
                                                    className="AddPurchaseTotal__Container__Format__SameInput"

                                                    {...params}
                                                    label="Zgjedh Bankën"
                                                />
                                            )}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                    overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                },
                                            }}
                                        />
                                    </div>
                                </div>

                                <TextField
                                    // style={{ width: "150px" }}
                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                    id="Total"
                                    label="Total 0"
                                    type="text"
                                    // value={valueWithVAT0.toFixed(2)}
                                    value={total !== null && total !== 0 ? total.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                    onChange={e => setTotal(e.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className='Boxx'>

                                <TextField
                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                    id="LedgerID"
                                    label="Llogaria Kontabël"
                                    variant="outlined"
                                    type="text"
                                    name='LedgerID'
                                    value="602-Shpenzimet e Financiare"
                                    aria-readonly
                                />

                                <TextareaAutosize
                                    style={{ height: "70px", marginLeft: "10px" }}
                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                    id="Comment"
                                    label="Komenti"
                                    type="text"
                                    name='Comment'
                                    value={coment}
                                    onChange={event => setComent(event.target.value)}
                                    variant="outlined"
                                    autoComplete="off"

                                />
                            </div>
                        </div>
                    </Box>
                </Paper>
            </form>
            <div></div>
        </div>
    );
}

export default InsertInteres;